/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdServerConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the Preview HTTP resource (factory product). */
export class PreviewResource {
}

export function createPreviewResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'preview',
    () => localUserProfile,
    undefined,
    undefined,
    {
      uri: AdServerConfig.obtain().getUri('preview'),
      responseType: 'text',
      transformResponse(data: any): any {
        if (!_.isString(data)) {
          return data;
        }
        if (data.indexOf('html') > -1) {
          return {document: data};
        }
        try {
          return JSON.parse(data);
        } catch (err) {
          return data;
        }
      }
    }
  );
}

export const previewResourceProvider = {
  provide: PreviewResource,
  useFactory: createPreviewResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

